const specs = {
  standard: {
    operation: 'create',
    create: {
      type: 'bool',
      product: 'exteriorRestyling_standard',
    },
  },
  numberOfImages: {
    operation: 'update',
    update: {
      type: 'mapTo',
      target: 'all',
      mapTo: [ 'numberOfImages' ],
    },
  },
};


const dependencies = {
  hard: [],
  soft: [],
};


export default { specs, dependencies };
